import { Select, ISelect } from "./";
import { useEffect, useState } from "react";
import { textChooser } from "../../../util/textChooser";
import { getUniversities } from "../../../apis/public.api";
import { formatValuesForSelect } from "../../../helpers/utilities";

interface CollegesProps extends ISelect {}

export const Colleges = (props: CollegesProps) => {

    const [colleges, setColleges] = useState([]);

    useEffect(() => {
        getUniversities().then((collegesData) => {
            formatValuesForSelect(setColleges , collegesData);
        })
    },[])

    return(
        <Select 
            {...props} 
            label={props?.label ?? textChooser("txt115")}
            values={colleges} 
            currentValue={props.currentValue} 
        />
    )
}